const toNumberedList = [
    (current: string, next: string, currentIndex: number) => {
        return `${current}${currentIndex + 1}. ${next}\n\n`;
    },
    ``,
] as const;

export const toFeedback = (errors: string[], feedback: HTMLParagraphElement) => {
    feedback.innerHTML = errors.reduce(...toNumberedList);
};
